module.exports = __webpack_public_path__ + "static/spider-web-a6b4bdef0c43b3ba31f5a40304a9ab65.svg";